import { Record } from 'immutable';

const {
    DELETE_TOKEN_REQUEST,
    DELETE_TOKEN_SUCCESS,

    SAVE_TOKEN_REQUEST,
    SAVE_TOKEN_SUCCESS,

    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,

    REGISTER_REQUEST,
    REGISTER_SUCCESS,
    REGISTER_FAILURE,

    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE,

    SAVE_USER_DATA_REQUEST,

    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE,

    GET_USER_DETAILS_REQUEST,
    GET_USER_DETAILS_SUCCESS,
    GET_USER_DETAILS_FAILURE,

    PROFILE_UPDATE_REQUEST,
    PROFILE_UPDATE_SUCCESS,
    PROFILE_UPDATE_FAILURE,

    PASSWORDLESS_REQUEST,
    PASSWORDLESS_SUCCESS,
    PASSWORDLESS_FAILURE,

    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,

} = require('./userActions').constants;

const InitialState = Record({
    error: null,
    isFetching: false,
    isLoggedIn: false,
    userData: {},
});

const initialState = new InitialState();

/**
 * ## galleryReducer function
 * @param {Object} state - initialState
 * @param {Object} action - type and payload
 */
export default function userReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.mergeDeep(state);

    switch (type) {
    case LOGIN_REQUEST:
    case DELETE_TOKEN_REQUEST:
    case SAVE_TOKEN_REQUEST:
    case PASSWORDLESS_REQUEST:
    case LOGOUT_REQUEST:
    case FORGOT_PASSWORD_REQUEST:
    case GET_USER_DETAILS_REQUEST:
    case PROFILE_UPDATE_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);
    case SAVE_TOKEN_SUCCESS:
    case PASSWORDLESS_SUCCESS:
    case LOGIN_SUCCESS:
        return state.set('isFetching', false)
            .set('userData', (payload && payload.user ? payload.user : {}))
            .set('isLoggedIn', true);
    case DELETE_TOKEN_SUCCESS:
    case LOGOUT_SUCCESS:
        return state.set('isFetching', false)
            .set('userData', {})
            .set('isLoggedIn', false);
    case PASSWORDLESS_FAILURE:
    case LOGIN_FAILURE:
    case LOGOUT_FAILURE:
        return state.set('isFetching', false)
            .set('isLoggedIn', false)
            .set('error', payload);
    case REGISTER_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);
    case REGISTER_SUCCESS:
        return state.set('isFetching', false)
            .set('isLoggedIn', true)
            .set('userData', (payload && payload.user ? payload.user : {}));

    case SAVE_USER_DATA_REQUEST: {
        const { userData } = state;

        return state.set('isFetching', false)
            .set('userData', (payload && payload.data && payload.data.user ? payload.data.user : userData));
    }

    case GET_USER_DETAILS_SUCCESS: {
        const { userData } = state;
        return state.set('isFetching', false)
            .set('userData', payload && payload.data && payload.data.user ? payload.data.user : userData);
    }

    case PROFILE_UPDATE_SUCCESS: {
        return state.set('isFetching', false)
            .set('userData', payload.data.user);
    }

    case FORGOT_PASSWORD_SUCCESS:
        return state.set('isFetching', false);

    case REGISTER_FAILURE:
    case FORGOT_PASSWORD_FAILURE:
    case PROFILE_UPDATE_FAILURE:
    case GET_USER_DETAILS_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);

    case RESET_PASSWORD_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);

    case RESET_PASSWORD_SUCCESS:
        return state.set('isFetching', false);

    case RESET_PASSWORD_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);

    default:
        return state;

    }
}
